abstract class Regex {
	static CPF = (value: string) =>
		/^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/.test(value);
	static Email = (value: string) =>
		/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
	static Phone = (value: string) => /^\+?\d{2}\d{2}\d{8,9}$/.test(value);
	static CNPJ = (value: string) =>
		/^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/.test(value);
}

export default Regex;
